import Logout from "../pages/Logout";

import type { Route } from "../../../routes/RouteModel";

export const logoutRoute: Route = {
  i18nName: "Logout",
  path: "/logout",
  hidden: true,
  component: Logout,
};
